<template>
	<core-layout-content medium>
		<core-layout-headline-and-actions>
			<template slot="headline">{{ $t("create_email_template") }}</template>
		</core-layout-headline-and-actions>

		<!-- Settings -->
		<template-settings currentType="create" />
	</core-layout-content>
</template>

<script>
import CoreLayoutContent from "@/modules/core/components/CoreLayoutContent"
import CoreLayoutHeadlineAndActions from "@/modules/core/components/CoreLayoutHeadlineAndActions"
import TemplateSettings from "../components/EmailMjmlTemplate/TemplateSettings"

export default {
	components: {
		CoreLayoutContent,
		CoreLayoutHeadlineAndActions,
		TemplateSettings
	}
}
</script>